import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Printer, PrintOptions } from '@ionic-native/printer/ngx';
import { ToastService } from 'src/app/core/toast.service';
import { ApiComandamesaService } from 'src/app/dao/api-comandamesa.service';
import { GlobalService } from 'src/app/dao/global.service';
import { PedidoService } from 'src/app/dao/pedido.service';
import { Pedido } from 'src/app/model/pedido';

@Component({
  selector: 'app-fechamento-pedido',
  templateUrl: './fechamento-pedido.page.html',
  styleUrls: ['./fechamento-pedido.page.scss'],
})
export class FechamentoPedidoPage implements OnInit {

  title = 'Novo Produto';
  pedido: Pedido;
  // cupom = [];
  cupom: string[];
  idPedido;
  cupom64;
  isAtendente = false;

  categorias = [];
  // tslint:disable-next-line: max-line-length
  constructor(private apicomandamesa: ApiComandamesaService, private router: Router, public global: GlobalService, private printer: Printer, private route: ActivatedRoute, private toast: ToastService, private apipedido: PedidoService) { }

  ngOnInit() {
    this.pedido = new Pedido();
    const idParam = this.route.snapshot.paramMap.get('idPedido');
    if (idParam) {
      // tslint:disable-next-line: radix
      this.loadPedido(idParam);
    }


    const isAtendente = localStorage.getItem("isAtendente");
    if (isAtendente !== "true") {
      console.log(isAtendente);
      console.log("a var nao existe ou é false");
    }else{
      console.log("a var existe");
      this.isAtendente = true;
    }

  }

  ionViewWillEnter() {

  }

  b64DecodeUnicode(str: any) {
    // tslint:disable-next-line: only-arrow-functions
    return decodeURIComponent(atob(str).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  }
  async loadPedido(id: any) {
    this.pedido = await this.apipedido.getById(id);
    if (this.global.impressao_tamanho === "0") {
      this.cupom = this.splitFunc(this.b64DecodeUnicode(this.pedido.cupom));
      this.cupom64 = this.pedido.cupom;
    } else {
      this.cupom = this.splitFunc(this.b64DecodeUnicode(this.pedido.cupom_reduzido));
      this.cupom64 = this.pedido.cupom_reduzido;
    }

  }

  splitFunc(cupomRecebido) {
    cupomRecebido = cupomRecebido.split('%0A');
    // tslint:disable-next-line: prefer-for-of
    for (let index = 0; index < cupomRecebido.length; index++) {
      const element = cupomRecebido[index];
      document.getElementById('cupom').innerHTML += element + `<br>`;
    }
    // tslint:disable-next-line: no-unused-expression
    return cupomRecebido;
  }

  delay(ms: number): Promise<boolean> {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(true);
      }, ms);
    });
  }

  print() {
    document.getElementById('divbtn').style.display = 'none';
    if (this.global.impressao_tipo == "pdf" || this.global.impressao_tipo == " " || !this.global.impressao_tipo || this.global.impressao_tipo.length === 0 ) {

    document.getElementById('divbtn').style.display = 'none';
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      // tslint:disable-next-line: prefer-const
      let options: PrintOptions = {
        name: 'MyDocument',
        duplex: true,
        orientation: 'landscape',
        monochrome: true
      };

      this.printer.print().then(async res => {
        await this.delay(4000);
        document.getElementById('divbtn').style.display = 'block';

      }).catch(async err => {
        document.getElementById('divbtn').style.display = 'block';
        console.log('err', err);
      });
    } else {
      window.print();
      document.getElementById('divbtn').style.display = 'block';
    }
  }else{
    window.open('techsprinter://ticket?value=' + this.cupom64);
    document.getElementById('divbtn').style.display = 'block';
  }
  }


  async reImprimir() {
    try {
      console.log(this.pedido);
      const result = await this.apipedido.setNaoImpresso(this.pedido.id);
      console.log(result);
      if(result == ""){
        let plataforma = window.location.hostname.replace('www.','');
        let dominioAUx = this.global.loja;

        if(this.pedido.consumidor_id == null || this.pedido.consumidor_id == ""){
          this.pedido.id_consumidor = null;
        }

        let ordens = await this.apipedido.getOrdens(this.pedido.token);
        let ordensAux = JSON.stringify(ordens);

        let pedidoAux = JSON.stringify(this.pedido);

        let json = '{' +
              ' "pedido":'+pedidoAux+' ,' +
              ' "prefixo":"'+dominioAUx+'",' +
              ' "ordens":'+ordensAux+',' +
              ' "plataforma":"'+plataforma+'"}';

        const resultJava = this.apipedido.inserirPedidoJava(json);
        console.log(resultJava);
      }
      this.toast.showSucess('Pedido reimpresso com sucesso');
    } catch (error) {
      this.toast.showError('Ocorreu um erro ao tentar reimprimir o Pedido');
      console.log(error);
    }

  }

  async onSubmit() {
    try {
      const result = await this.apipedido.save(this.pedido);
      this.pedido.id = result.id;
      this.toast.showSucess('Pedido salvo com sucesso');
    } catch (error) {
      this.toast.showError('Ocorreu um erro ao tentar salvar o Pedido');
      console.log(error);
    }
  }
}
